export interface CertificateConfig {
  gameName: string;
  playerName: string;
  stats: string[];
  subtitle?: string;
  backgroundColor?: { start: string; end: string };
}

export const createCertificateCanvas = (config: CertificateConfig): Promise<HTMLCanvasElement> => {
  return new Promise<HTMLCanvasElement>((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d")!;

    // Set canvas size
    canvas.width = 600;
    canvas.height = 400;

    // Create gradient background
    const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
    gradient.addColorStop(0, config.backgroundColor?.start || "#6366f1");
    gradient.addColorStop(1, config.backgroundColor?.end || "#3b82f6");

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Set text properties
    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "center";

    // Title
    ctx.font = "bold 28px Arial";
    ctx.fillText(config.gameName, canvas.width / 2, 80);

    // Create certificate box
    ctx.fillStyle = "rgba(255, 255, 255, 0.2)";
    ctx.fillRect(100, 120, 400, 200);

    // Player name
    ctx.fillStyle = "#ffffff";
    ctx.font = "bold 24px Arial";
    ctx.fillText(config.playerName, canvas.width / 2, 160);

    // Stats
    ctx.font = "bold 18px Arial";
    let yPosition = 180;
    config.stats.forEach((stat) => {
      ctx.fillText(stat, canvas.width / 2, yPosition);
      yPosition += 30;
    });

    // Footer
    ctx.font = "14px Arial";
    ctx.fillText(config.subtitle || "Game Champion!", canvas.width / 2, 290);

    resolve(canvas);
  });
};

export const downloadCertificate = async (config: CertificateConfig, filename: string) => {
  try {
    const canvas = await createCertificateCanvas(config);

    const link = document.createElement("a");
    link.download = filename;
    link.href = canvas.toDataURL();
    link.click();
  } catch (error) {
    console.error("Error generating certificate:", error);
  }
};

export const getDayOfWeek = () => {
  const date = new Date();
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dayName = days[date.getDay()];
  const monthName = months[date.getMonth()];
  const dayOfMonth = date.getDate();

  // Add ordinal suffix
  const getOrdinalSuffix = (day: number) => {
    if (day >= 11 && day <= 13) {
      return "th";
    }
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${dayName}, ${monthName} ${dayOfMonth}${getOrdinalSuffix(dayOfMonth)}`;
};

export const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return mins > 0 ? `${mins}:${secs.toString().padStart(2, "0")}` : `${secs}s`;
};
